import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'Index',
    component: () => import(/* webpackChunkName: "index" */ '../components/pages/Index.vue')
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: () => import(/* webpackChunkName: "dashboard" */ '../components/pages/DashboardPage.vue')
  },
  {
    path: '/dashboard/user',
    name: 'UserData',
    component: () => import(/* webpackChunkName: "dashboard" */ '../components/pages/UserDataPage.vue')
  },
  {
    path: '/dashboard/access',
    name: 'AccessData',
    component: () => import(/* webpackChunkName: "dashboard" */ '../components/pages/AccessDataPage.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
